<template>
  <li :class="classes" v-on="$listeners">
    <slot />
  </li>
</template>

<script>
import classes from '~~/common/vue/mixins/classes';
import scrollIntoParentView from '~~/common/vue/mixins/scroll-into-parent-view';

export default {
  name: 'EListItem',
  mixins: [classes, scrollIntoParentView],
  props: {
    /**
     * Toggles the smooth active style transition
     */
    transition: {
      type: Boolean,
      cssClass: true,
      default: true,
    },
    highlighted: {
      type: Boolean,
      cssClass: true,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin li-highlight {
  background-color: $aqua-10;
}

.list-item {
  cursor: pointer;
  font-size: $font-m;
  list-style-type: none;
  padding: $space-s;

  &:hover,
  &:active {
    @include li-highlight;
  }

  &:focus,
  &:focus-within {
    @extend %keyboard-nav-focus;
  }
}

.list-item--highlighted {
  @include li-highlight;
}

.list-item--transition {
  transition: background-color $timing-2s $easing;
}
</style>

<docs>
```js
<EList>
  <EListItem>First item</EListItem>
  <EListItem>Second item</EListItem>
  <EListItem>Third item</EListItem>
</EList>
```
</docs>
